import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, PropType, ref } from 'vue'
import { IFacturaEDialogModel } from '@/components/billing/FacturaEDialog/types/FacturaEDialogTypes'
import LfBlueTitleComponent from '@/components/HeaderTitle/LfBlueTitleComponent.vue'
import LfActionsBarComponent from '@/components/ActionsBar/LfActionsBarComponent.vue'
import { LabelButtonVariant } from '@/components/forms/buttons/types/ButtonTypes'
import { ActionBarButton, ActionName } from '@/components/ActionsBar/types/ActionBarComponentTypes'
import useActionsFacturaEDialog from '@/components/billing/FacturaEDialog/composables/useActionsFacturaEDialog'
import SpinnerLayerComponent from '@/components/Spinner/SpinnerLayerComponent.vue'
import { useI18n } from 'vue-i18n-composable'


export default /*#__PURE__*/_defineComponent({
  __name: 'PreviewDocumentComponent',
  props: {
  model: {
    type: Object as PropType<IFacturaEDialogModel>,
    required: true
  }
},
  setup(__props) {

const props = __props;



const { t } = useI18n()

const texts = {
  title: t('components.facturae_dialog.preview.title').toString(),
  download: t('action_buttons.download').toString(),
  prev: t('action_buttons.prev').toString(),
  cancel: t('action_buttons.cancel').toString(),
  send: t('action_buttons.send').toString(),
  spinner: t('components.spinner.generating_document').toString(),
}

const {
  close,
  resetDocument,
  downloadDocument,
  prev,
  next,
  generateDocument,
  hasDocumentGenerated,
} = useActionsFacturaEDialog(props.model)

const resourceUrl = ref(`${ process.env.VUE_APP_FRONT_URL }`)

const documentPath = computed(() => `data:application/pdf;base64,${ props.model?.documentContent }`)

const buttons = computed(() => {
  return [
    {
      tooltip: texts.cancel,
      variant: LabelButtonVariant.OUTLINED,
      action: ActionName.CLOSE,
      enabled: true
    },
    {
      tooltip: texts.prev,
      variant: LabelButtonVariant.OUTLINED,
      action: ActionName.PREV,
      enabled: true
    },
    {
      tooltip: texts.download,
      variant: LabelButtonVariant.OUTLINED,
      action: ActionName.DOWNLOAD,
      enabled: hasDocumentGenerated.value
    },
    {
      tooltip: texts.send,
      variant: LabelButtonVariant.SOLID,
      action: ActionName.SEND_FACTURA_E,
      enabled: hasDocumentGenerated.value
    }
  ] as ActionBarButton []
})

function onExecuteAction(action: string) {
  switch (action) {
    case ActionName.PREV:
      resetDocument()
      prev()
      return
    case ActionName.CLOSE:
      close()
      return
    case ActionName.DOWNLOAD:
      downloadDocument()
      return
    case ActionName.SEND_FACTURA_E:
      next()
      return
  }
}

onMounted(async () => await generateDocument())


return { __sfc: true,props, t, texts, close, resetDocument, downloadDocument, prev, next, generateDocument, hasDocumentGenerated, resourceUrl, documentPath, buttons, onExecuteAction, LfBlueTitleComponent, LfActionsBarComponent, SpinnerLayerComponent }
}

})